<template>
  <div class="orgmapdev">
    <el-button :loading="orgLoading" style="margin-top:0.8rem;" size="small" type="primary" @click="saveOrganization">保存组织架构</el-button>
    <div style="overflow:auto;height:auto; width:max-content">
      <vue-okr-tree 
      @node-click="treeClick" 
      ref="tree" 
      node-key="uid"
      :render-content="renderContent"
      :data="testData">
      </vue-okr-tree> 
    </div>
    <el-dialog
    v-dialogDrag
      title="人员信息"
      :close-on-click-modal="false"
      :visible.sync="saleTeamDia"
      width="40%">
      <div class="team-introduction-only">
        <div class="team-introduction-only">
          <span>照片</span>
          <el-upload 
            class="avatar-uploader"  
            :http-request="(e)=>{uploadfileUser(e)}" 
            action="#" 
            :before-upload="beforeAvatarUpload"
            :show-file-list="false">
            <img v-if="userData.stationImg" :src="userData.stationImg" class="diy-con-img">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </div>
        <div class="team-introduction-only">
          <span>名称</span>
          <el-input maxlength="4" show-word-limit v-model="userData.stationUser" placeholder="任职者"></el-input>
        </div>
        <div class="team-introduction-only">
          <span>岗位</span>
          <el-input maxlength="10" show-word-limit v-model="userData.stationName" placeholder="岗位名称"></el-input>
        </div>
        <div class="team-introduction-only">
          <span>描述</span>
          <el-input maxlength="80" show-word-limit type="textarea" v-model="userData.stationDuty" placeholder="岗位职责"></el-input>
        </div>      
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="userClick">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {VueOkrTree} from 'vue-okr-tree';
import 'vue-okr-tree/dist/vue-okr-tree.css'
import api from '@/apis/device/device'
import upapi from '@/apis/upload'
export default {
  components:{
    VueOkrTree
  },
  data(){
    return{
      saleTeamDia:false,//新增信息弹框
      testData: [{
        stationUser: '',
        stationName:'',
        parentId:0,
        stationImg: require('@/assets/images/defaultAvt.jpg'),
        stationDuty: '暂无介绍',
        children: [{
          stationUser: '',
          stationName:'',
          uid:parseInt(Math.random()*100000000,10)+1,
          stationImg: require('@/assets/images/defaultAvt.jpg'),
          stationDuty: '暂无介绍',
        },{
          stationUser: '',
          stationName:'',
          uid:parseInt(Math.random()*100000000,10)+1,
          stationImg: require('@/assets/images/defaultAvt.jpg'),
          stationDuty: '暂无介绍',
        }]
      }],
      orgLoading:false,//加载状态
      userData:'',//临时用户数据
    }
  },
  mounted(){
    this.getOrganization()
  },
  methods:{
    //鼠标移入
    hoverClick(e){
      e.target.lastChild.style.opacity = 1
    },
    //鼠标移出
    outClick(e){
      e.target.lastChild.style.opacity = 0
    },
    //操作树方法
    treeClick(a){
      this.userData = a
      this.saleTeamDia = true;
      let _width = document.getElementsByClassName('team-intr')
      _width[0].style.width = _width[0].scrollWidth+'px'
    },
    //自定义树节点
    renderContent (h, node) {
      return (
        <div>
          <div onmouseleave={(e)=>this.outClick(e)} onmouseenter={(e)=>this.hoverClick(e)} class={['diy-wrapper', node.isCurrent ? 'current-select' : ''] }>
            <div class="diy-left-box">
              <img class="diy-con-img" src={node.data.stationImg}/>
            </div>
            <div class="diy-right-box">
              <p>{node.data.stationUser}</p>
              <p>{node.data.stationName}</p>
              <p>{node.data.stationDuty}</p>
            </div>
            <div class="diy-right-button">          
              <el-button icon="el-icon-plus" class="diy-con-button" onClick={(e)=>this.addTree(e,node)} size="mini" type="success"></el-button>      
              <br></br>
              <el-button v-show={node.data.parentId!=0} icon="el-icon-delete" class="diy-con-button" onClick={(e)=>this.delTree(e,node)} size="mini" type="danger"></el-button>         
            </div>
          </div>
        </div>
      )
    },
    //添加节点
    addTree(e,data){
      e.stopPropagation() 
      this.addUnder(data)
    },
    //删除节点
    delTree(e,data){
      e.stopPropagation()
      this.delUser(data.data)
    },
    //人员确定
    userClick(){
      this.saleTeamDia = false
    },
    //添加下级
    addUnder(keyData){
      this.$refs.tree.append({
        stationUser:'',
        stationName:'',
        uid:parseInt(Math.random()*100000000,10)+1,
        stationImg:require('@/assets/images/defaultAvt.jpg'),
        stationDuty:'暂无介绍',
      },(keyData))
      this.saleTeamDia = false
    },
    //人员删除
    delUser(data){
      if(data.id){
        this.$confirm('确认删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          api.delOpsTeam([data.id]).then(res=>{
            if(res.code==10000){
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.saleTeamDia = false
              this.getOrganization()
            }else{
              this.$message.error(res.message);
              return;
            }
          })
        })
      }else{
        this.$refs.tree.remove(data)
        this.saleTeamDia = false
      }
    },
    //保存组织架构
    saveOrganization(){
      this.orgLoading = true;
      api.saveOpsTeam(this.testData).then(res=>{
        if(res.code==10000){
          this.$message.success('保存成功');
          this.getOrganization()
          this.saleTeamDia = false
          this.orgLoading = false;
        }else{
          this.$message.error(res.message);
          this.orgLoading = false;
          return;
        }
      })
    },
    //获取组织架构
    getOrganization(){
      api.getOpsTeam().then(res=>{
        if(res.code==10000){
          if(res.data.length!=0){
            this.testData = res.data
          }
        }
      })
    },
    //图片上传成功的回调函数人员
    uploadfileUser(val) {
      let fd = new FormData()
      fd.append('file', val.file)
      upapi.upload(fd).then((res) => {
        if (res.code == 10000) {
          this.userData.stationImg = res.data
        } else {
          this.$message.error(res.message)
          return;
        }
      })
    },
    //判断上传文件格式是否合法
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg'||file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG或PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
  }
}
</script>
<style lang="less">
.orgmapdev{overflow: auto; margin-bottom: 2rem;
  .diy-right-button{
    width: 2rem;
    opacity:0;
  }
  .diy-wrapper{ display: flex; flex-direction: row; border: #3570ff solid 1px; border-radius: 6px; padding:10px;
    .diy-con-img{ width: 3rem; height: 3.5rem; border-radius: 6px; display: block;}
    .diy-con-button{margin:0.2rem 0;}
    .diy-right-box{ margin-left: 15px; font-size: .65rem; width: 4rem; overflow: hidden; text-align: left; display: flex; flex-direction: column;
      p:nth-child(1){ color: #fff; font-weight: bold; margin-bottom: 4px;}
      p:nth-child(2){ opacity: .6; font-size: .55rem; margin-bottom: 3px;}
      p:nth-child(3){ height: 100%; flex: 1; overflow: hidden; font-size: .55rem;}
    }
  }
  .vertical .org-chart-node-label .org-chart-node-label-inner{ padding:0; margin:0px 10px;}
  .el-divider{ background-color: #3570ff;}
  .vertical .org-chart-node-children:before,.vertical .org-chart-node:after, .vertical .org-chart-node:before{ border-color: #3570ff;}

    .team-introduction-only{
    .team-introduction-only{ margin-bottom: 15px; display: flex; flex-direction: row;
      &>span{display: inline-block; width: 6rem; background: #3570ff; height: 1.8rem; line-height: 1.8rem; flex-shrink: 0; text-align: right; padding:0px 15px;}
      .el-input{ flex: 1; width: 100%;}
    }
    .avatar-uploader{ width: 6rem; height: 7rem;
      img{ width: 6rem; height: 7rem;}
    }
  }
}
</style>
